import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  colspan: "2",
  class: "character-select-mode"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "member-tags" }
const _hoisted_5 = { colspan: "2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "members" }
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = { class: "buildname-select" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "team-tags" }
const _hoisted_12 = { colspan: "2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CharacterSelect = _resolveComponent("CharacterSelect")!
  const _component_MemberItem = _resolveComponent("MemberItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.characterSelectMode)
      ? (_openBlock(), _createBlock(_component_CharacterSelect, {
          key: 0,
          visible: true,
          characters: _ctx.characters,
          "onUpdate:characters": _ctx.updateCharacters
        }, null, 8, ["characters", "onUpdate:characters"]))
      : (_openBlock(), _createBlock(_component_CharacterSelect, {
          key: 1,
          visible: true,
          characters: _ctx.replacements,
          "onUpdate:characters": _ctx.updateReplacements
        }, null, 8, ["characters", "onUpdate:characters"])),
    _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[9] || (_cache[9] = _createElementVNode("th", null, "Team Name", -1)),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.workTeam.name) = $event)),
              type: "text",
              minlength: "1",
              maxlength: "16",
              placeholder: "INPUT TEAM NAME"
            }, null, 512), [
              [_vModelText, _ctx.workTeam.name]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[10] || (_cache[10] = _createElementVNode("th", null, "Character Select Mode", -1)),
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              class: "character-select-mode",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.characterSelectModeOnClick && _ctx.characterSelectModeOnClick(...args)))
            }, _toDisplayString(_ctx.characterSelectMode ? 'REPLACEMENTS' : 'MEMBERS'), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_1, [
            (!_ctx.characterSelectMode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " チームメンバーを選択して下さい "))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selectedMemberName() + 'の代替キャラクターを選択して下さい'), 1))
          ])
        ]),
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("td", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MEMBER_TAG_LIST, (tag) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass('tag' + _ctx.tagSelectedClass(tag)),
                key: tag,
                onClick: ($event: any) => (_ctx.tagOnClick(tag))
              }, _toDisplayString(tag), 11, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("tr", _hoisted_7, [
          _createElementVNode("td", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workTeam.members, (member) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass('member' + _ctx.memberSelectedClass(member.id)),
                key: member.id
              }, [
                _createVNode(_component_MemberItem, {
                  member: member,
                  onClick: ($event: any) => (_ctx.memberOnClick(member.id))
                }, null, 8, ["member", "onClick"])
              ], 2))
            }), 128)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedMemberBuildname) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.buildnameOnChange && _ctx.buildnameOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildnames, (value) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: value,
                    value: value
                  }, _toDisplayString(value), 9, _hoisted_10))
                }), 128))
              ], 544), [
                [_vShow, _ctx.buildnames.length],
                [_vModelSelect, _ctx.selectedMemberBuildname]
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[11] || (_cache[11] = _createElementVNode("th", null, "Short Note", -1)),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "description",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.workTeam.description) = $event)),
              type: "text",
              maxlength: "40",
              placeholder: "INPUT NOTE"
            }, null, 512), [
              [_vModelText, _ctx.workTeam.description]
            ])
          ])
        ]),
        _createElementVNode("tr", _hoisted_11, [
          _createElementVNode("td", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workTeamTags, (tag) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(_ctx.teamTagSelected(tag) ? 'tag selected' : 'tag'),
                key: tag,
                onClick: ($event: any) => (_ctx.teamTagOnClick(tag))
              }, _toDisplayString(tag), 11, _hoisted_13))
            }), 128))
          ])
        ]),
        _createElementVNode("tr", null, [
          _cache[12] || (_cache[12] = _createElementVNode("th", null, "Tags", -1)),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "team-tags",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.txtTeamTags) = $event)),
              type: "text",
              maxlength: "40",
              placeholder: "INPUT TAGS",
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.txtTeamTagsOnChange && _ctx.txtTeamTagsOnChange(...args)))
            }, null, 544), [
              [_vModelText, _ctx.txtTeamTags]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelOnClick && _ctx.cancelOnClick(...args)))
      }, "cancel"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.okOnClick && _ctx.okOnClick(...args)))
      }, "ok")
    ])
  ], 64))
}